import { ArrowRight, HeartHandshake, Scale } from "lucide-react";
import { Eyebrow, Reveal } from "@/lib/motion";

const EXPERIENCED = [
  "Founding attorney with a national-firm litigation background",
  "Of counsel focused on construction & commercial litigation",
  "Associate attorney with years of daily courtroom experience",
  "Senior paralegal support with 13+ years in the legal field",
];

const BOUTIQUE = [
  "Direct communication with your legal team",
  "A dedicated legal team behind every matter",
  "Plain-English counsel, real relationships",
  "Your success treated as personal",
];

function Panel({ icon: Icon, title, items, delay }) {
  return (
    <Reveal delay={delay} className="h-full">
      <div className="flex h-full flex-col border border-border bg-card p-8 sm:p-10">
        <span className="flex h-11 w-11 items-center justify-center border border-gold/50 text-gold">
          <Icon className="h-4 w-4" strokeWidth={1.5} />
        </span>
        <h3 className="mt-6 font-serif text-2xl font-medium tracking-tight">{title}</h3>
        <ul className="mt-6 flex-1 space-y-3">
          {items.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-muted-foreground">
              <span className="mt-2 h-1 w-1 shrink-0 bg-gold" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </Reveal>
  );
}

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="border-y border-border bg-card/30 py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal><Eyebrow>The Difference</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl lg:text-7xl">
            The experience to handle complex matters. <span className="italic text-gold">The attention to understand what matters to you.</span>
          </h2>
        </Reveal>

        <div className="relative mt-14 grid gap-6 lg:grid-cols-2 lg:gap-10">
          <Panel icon={Scale} title="Experienced attorneys" items={EXPERIENCED} delay={0.1} />
          <Panel icon={HeartHandshake} title="Boutique attention" items={BOUTIQUE} delay={0.2} />
          <span className="absolute left-1/2 top-1/2 hidden h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold/60 bg-background font-serif text-2xl italic text-gold lg:flex">
            &
          </span>
        </div>

        <Reveal delay={0.25}>
          <div className="mt-14 text-center">
            <p className="mx-auto max-w-xl font-serif text-2xl font-light leading-snug sm:text-3xl">
              You shouldn't have to choose. <span className="italic text-gold">Here, you don't.</span>
            </p>
            <button
              data-testid="why-us-book-btn"
              onClick={() => window.dispatchEvent(new CustomEvent("hlt:open-booking"))}
              className="group mt-8 inline-flex cursor-pointer items-center gap-3 bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-primary-foreground transition-all duration-300 hover:brightness-110"
            >
              See for Yourself — Book Free
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
